declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

function fromWindow(key: string): string | undefined {
  if (typeof window !== "undefined" && window.__ENV__) {
    const val = window.__ENV__[key];
    if (val && !val.startsWith("${")) return val;
  }
  return undefined;
}

function fromProcess(key: string): string | undefined {
  return typeof process !== "undefined" ? process.env[key] : undefined;
}

export const runtimeEnv = {
  VITE_INRESI_API_HOST: () =>
    fromWindow("VITE_INRESI_API_HOST") ??
    import.meta.env.VITE_INRESI_API_HOST ??
    fromProcess("VITE_INRESI_API_HOST"),
  VITE_INRESI_WEBAPP_URL: () =>
    fromWindow("VITE_INRESI_WEBAPP_URL") ??
    import.meta.env.VITE_INRESI_WEBAPP_URL ??
    fromProcess("VITE_INRESI_WEBAPP_URL"),
  VITE_INRESI_CMS_APP_URL: () =>
    fromWindow("VITE_INRESI_CMS_APP_URL") ??
    import.meta.env.VITE_INRESI_CMS_APP_URL ??
    fromProcess("VITE_INRESI_CMS_APP_URL"),
  VITE_MIXPANEL_TOKEN: () =>
    fromWindow("VITE_MIXPANEL_TOKEN") ??
    import.meta.env.VITE_MIXPANEL_TOKEN ??
    fromProcess("VITE_MIXPANEL_TOKEN"),
  VITE_POSTHOG_KEY: () =>
    fromWindow("VITE_POSTHOG_KEY") ??
    import.meta.env.VITE_POSTHOG_KEY ??
    fromProcess("VITE_POSTHOG_KEY"),
  VITE_POSTHOG_HOST: () =>
    fromWindow("VITE_POSTHOG_HOST") ??
    import.meta.env.VITE_POSTHOG_HOST ??
    fromProcess("VITE_POSTHOG_HOST"),
};
